import { Component } from "../interfaces/Form/Component";
import UserInterface from "../interfaces/UserInterface";
import InputDataType from "../interfaces/InputDataType";

export const isWidget = (component: Component, widgetName: string) =>
  component.props.ui.widget === widgetName;

export const isLayoutComponent = (component: Component) => {
  return "nested" in component.props;
};

export const isFormComponent = (component: Component) =>
  isWidget(component, "Variable") || !isLayoutComponent(component);

export const isComponentRequired = (component: Component) => {
  if (!("validate" in component.props)) return false;
  return component.props.validate && component.props.validate.required;
};

export const isType = (component: Component, type: string) =>
  component.props.type === type;

export const hasJsonValidation = (component: Component) => {
  if (!("validate" in component.props)) return false;
  return component.props.validate && component.props.validate.json;
};

export const getComponentDataType = (component: Component) => {
  if (component.props.ui.widget === "InputEmail") return InputDataType.email;
  if (component.props.ui.widget === "InputPhone") return InputDataType.phone;
  return (component.props.type as InputDataType) || InputDataType.string;
};

export const getIDParts = (id: string, idPrefix: string) =>
  id.slice(idPrefix.length, id.length).split("/");

export const getLastPartOfID = (id: string) => {
  const idParts = id.split("/");
  return idParts[idParts.length - 1];
};

export const hasConditional = (component: Component) =>
  "conditional" in component.props;

export const injectWidget = (ui: UserInterface | undefined, widget: string) => {
  if (!ui) return { widget };
  if (!ui.widget)
    return {
      ...ui,
      widget
    };
  return ui;
};
